import React, { FunctionComponent } from 'react';
import { WEEKDAYS } from '@/constants';
import { Box, Chip } from '@mui/material';

export const WeekdaySelection: FunctionComponent<
    React.PropsWithChildren<{
        selectedWeekdays: string[]; // think of safer method
        onSelect: (weekday: string) => void;
        onUnSelect: (weekday: string) => void;
        disabled?: boolean;
    }>
> = ({ selectedWeekdays, onSelect, onUnSelect, disabled = false }) => {
    const clickHandler = (weekday: string) => () => {
        if (!disabled) {
            const handler = !selectedWeekdays.includes(weekday)
                ? onSelect
                : onUnSelect;

            handler(weekday);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                my: 2,
            }}
        >
            {Object.keys(WEEKDAYS).map((weekday) => (
                <Chip
                    sx={{
                        mx: 1,
                    }}
                    variant={
                        selectedWeekdays.includes(weekday)
                            ? 'filled'
                            : 'outlined'
                    }
                    color='primary'
                    key={weekday}
                    size='medium'
                    label={WEEKDAYS[weekday]}
                    onClick={clickHandler(weekday)}
                    disabled={disabled}
                />
            ))}
        </Box>
    );
};
